import React from "react";
import { Button, Card, CardBody, CardFooter, CardHeader } from "reactstrap";


interface ToolsCardProps {
    title: string
    description: string
    onChange: () => void
    buttonText: string
    disabled: boolean
}

const ToolsCard = (props: ToolsCardProps) => {

    return (
        <Card>
            <CardHeader tag="h5" style={{ flexDirection: 'row' }}>
                {props.title}
            </CardHeader>
            <CardBody>
                {props.description}
            </CardBody>
            <CardFooter>
                <Button disabled={props.disabled} onClick={props.onChange}>{props.buttonText}</Button>
            </CardFooter>
        </Card>
    )
}

export default ToolsCard;
